/**
 * @author Nihar <nihar.baishya@314ecorp.com>
 * @description NewClaimWorkList
 */

import _ from 'lodash';
import { Button, Dropdown } from 'antd';
import { Down, Plus } from '@icon-park/react';
import { Link } from 'react-router-dom';

import { getNewWorkListPath } from 'utils/router';
import { WORKLIST_TYPES } from 'app-constants/claims/workLists';

const menuProps = _.map(WORKLIST_TYPES, ({ key, label }) => ({ key, label: <Link to={getNewWorkListPath(key)}>{label}</Link> }));

const NewClaimWorkList: React.FC = () => {
	return (
		<Dropdown menu={{ items: menuProps, className: 'min-w-[180px]' }}>
			<Button type='primary'>
				<Plus />
				{'New Worklist'}
				<Down />
			</Button>
		</Dropdown>
	);
};

export default NewClaimWorkList;
